import React, { useState, useRef, useEffect } from 'react';
import PropertiesService from '../../../Services/PropertiesService'; // Make sure this is imported correctly
import DateFormatFile from '../dateFormatFile/DateFormatFile';
import * as pdfjsLib from "pdfjs-dist";
import { extractDateFromDocument, formatReadableDate } from '../../../utils/dateExtractor';

const DateFormatDocs = ({ documentsData, handleUpdatedDocuments, onDeleteFile, onEditFile, onAddFile }) => {
    const [documents, setDocuments] = useState(documentsData?.date || []);
    const [isLoading, setIsLoading] = useState(false);
    const fileInputRef = useRef(null);

    const handleDateFormatFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const formData = new FormData();
        formData.append('image', file);
        setIsLoading(true);

        try {
            const response = await PropertiesService.UploadFiles(formData);
            const data = response.Location;
            setIsLoading(false);
            
            const docId = `input-${documents.length === 0 ? 1 : documents.length + 1}`;
            const newDocument = {
                id: docId,
                data,
                manualDate: '',
                isExtracting: true
            };

            setDocuments((prevState) => {
                if (!Array.isArray(prevState)) {
                    prevState = [];
                }
                const updatedDocuments = [...prevState, newDocument];
                onAddFile(updatedDocuments);
                return updatedDocuments;
            });
            alert('File uploaded successfully.');

            // Perform OCR asynchronously
            try {
                const res = await extractDateFromDocument(file, pdfjsLib);
                const extractedDate = res.date || '';
                const detectedAllDates = res.allDates || [];
                setDocuments((prevState) => {
                    if (!Array.isArray(prevState)) prevState = [];
                    const updated = prevState.map(doc =>
                        doc.id === docId ? { 
                            ...doc, 
                            manualDate: extractedDate, 
                            allDates: detectedAllDates,
                            declare: !!extractedDate, 
                            isExtracting: false,
                            selectedMode: detectedAllDates.length > 0 ? 'extracted' : 'manual'
                        } : doc
                    );
                    onAddFile(updated);
                    return updated;
                });
            } catch (ocrErr) {
                console.error('OCR Error:', ocrErr);
                setDocuments((prevState) => {
                    if (!Array.isArray(prevState)) prevState = [];
                    const updated = prevState.map(doc =>
                        doc.id === docId ? { ...doc, isExtracting: false, selectedMode: 'manual' } : doc
                    );
                    onAddFile(updated);
                    return updated;
                });
            }

        } catch (error) {
            console.error('Error uploading file:', error);
            alert('There was an error uploading the file.');
            setIsLoading(false);
        }
    };


    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    const handleManualDateChange = (e, id) => {
        const newDate = e.target.value;
        setDocuments((prevDocuments) => {
            const updated = prevDocuments.map((doc) =>
                doc.id === id ? { ...doc, manualDate: newDate, declare: !!newDate } : doc
            );
            onAddFile(updated);
            return updated;
        });
    };

    const handleDeclareDate = (e, id) => {
        const isChecked = e.target.checked;
        setDocuments((prevDocuments) => {
            const updated = prevDocuments.map((doc) =>
                doc.id === id ? { ...doc, declare: isChecked } : doc
            );
            onAddFile(updated);
            return updated;
        });
    };

    useEffect(() => {
    }, [documents]);

    return (
        <div className="document-manager">
            <div className={documents.length === 1 ? "row justify-content-center" : "row justify-content-start"}>
                <p>{documents.length}</p>
                {documents.length > 0 ? (
                    documents.map((document) => (
                        <div key={document.id} className="col-md-6">
                            <DateFormatFile
                                file={document}
                                onDeleteFile={onDeleteFile}
                                onEditFile={onEditFile}
                                onAddFile={onAddFile}
                            />
                            {document.isExtracting ? (
                                <p style={{ color: 'var(--color-turquoise-teal)', fontWeight: '600' }}>Reading document date... please wait...</p>
                            ) : !document.manualDate ? (
                                <>
                                    <p>No dates found. Please enter a date:</p>
                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ width: '200px' }}
                                        value={document.manualDate || ''}
                                        onChange={(e) => handleManualDateChange(e, document.id)}
                                    />
                                </>
                            ) : (
                                <>
                                    <input
                                        type="date"
                                        className="form-control mb-1"
                                        style={{ width: '200px' }}
                                        value={document.manualDate || ''}
                                        onChange={(e) => handleManualDateChange(e, document.id)}
                                    />
                                    <p style={{ fontSize: '13px', color: 'var(--color-turquoise-teal)', fontWeight: '600', marginTop: '4px' }}>
                                        Auto-read Date: {formatReadableDate(document.manualDate)}
                                    </p>
                                    <p style={{ fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <span style={{ color: "var(--color-turquoise-teal)", fontWeight: '500' }}>
                                            I confirm this date is correct
                                        </span>
                                        <input
                                            type="checkbox"
                                            checked={document.declare || false}
                                            onChange={(e) => handleDeclareDate(e, document.id)}
                                        />
                                    </p>
                                </>
                            )}
                        </div>
                    ))
                ) : (
                    <p>No documents available.</p>
                )}

            </div>
            <div className="add-file-container">
                <input
                    ref={fileInputRef}
                    type="file"
                    onChange={handleDateFormatFileChange}
                    accept=".pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg, .csv,.svg"
                    style={{ display: 'none' }}
                    disabled={isLoading}
                />
                <button onClick={triggerFileInput} disabled={isLoading}>
                    {isLoading ? 'Uploading...' : 'Add New Document'}
                </button>
            </div>
        </div>
    );
};

export default DateFormatDocs;

